module.exports = __webpack_public_path__ + "img/login_bottom.7172fbdb.svg";